import { BusyButton } from "@pjs/core-ui";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";

angularAMD.component(
    "busyButton",
    react2angular(BusyButton, [
        "className",
        "onClick",
        "children",
        "ariaLabel",
        "disabled",
        "dataHook",
        "type",
        "ariaDescribedBy",
        "autoFocus",
        "ariaDisabled",
        "isBusy"
    ])
);
